import { FormattedMessage, useIntl } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormValidation,
} from 'ui'
import { create } from 'vest'
import { ProgressiveDiscountEffect as ProgressiveDiscountEffectType } from '../../../../typings'
import { messages } from './messages'
import { benefitSuite, triggerSuite } from './validation'
import { ViewProgressiveDiscount } from './View'

type Props = {
  name: string
}

export function ProgressiveDiscountEffect(props: Props) {
  const { name } = props

  const intl = useIntl()

  const validation = create((values: ProgressiveDiscountEffectType) => {
    triggerSuite(intl, name)(values.trigger)
    benefitSuite(intl, name)(values.benefit)
  })

  useFormValidation('progressive-discount-effect', {
    fieldName: name,
    validateFn: validation,
  })

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage {...messages.title} />
        </SectionTitle>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <ViewProgressiveDiscount name={name} />
      </SectionContent>
    </Section>
  )
}
